import request from '@/API/';

export default {
  login: (payload) => {
    return request.post('user/login', {
      ...payload,
    });
  },
  fetchUser: () => {
    return request.get('user/ud');
  },
  remindPassword: (payload) => {
    return request.post('user/forgot', {
      username: payload,
    });
  },
  createAccount: (payload) => {
    return request.post('user/create-customer', {
      ...payload,
    });
  },
  register: (payload) => {
    return request.post('user/registration', {
      ...payload,
    });
  },
  createCheckoutSession: (payload) => {
    return request.post('user/create-checkout-session', {
      ...payload,
    });
  },
  fetchPackagesList: () => {
    return request.get('user/module-list');
  },
};
